import React, { useEffect } from 'react';
import { useDisclosure } from '@cardboard-ui/react';
import { useFolderItem } from '../../../ItemViewerProvider';
import { UnsavedSignatureSetupDialog } from '../UnsavedSignatureSetupDialog';

interface ConfirmCloseDialogProps {
  isDocumentDirty: boolean;
}

export const ConfirmCloseDialog = ({
  isDocumentDirty,
}: ConfirmCloseDialogProps) => {
  const { closeViewer, setCloseHandler } = useFolderItem();

  const {
    isOpen: isUnsavedSignatureSetupDialogOpen,
    onClose: onUnsavedSignatureSetupDialogClose,
    onOpen: onUnsavedSignatureSetupDialogOpen,
  } = useDisclosure();

  useEffect(() => {
    if (isDocumentDirty) {
      setCloseHandler(() => {
        // If document is dirty, we need to show an Unsaved Signature Setup Dialog, and NOT close the viewer
        onUnsavedSignatureSetupDialogOpen();
      });
    } else {
      // If document is not dirty, we can close the viewer
      setCloseHandler(undefined);
    }
  }, [isDocumentDirty]);

  return (
    <UnsavedSignatureSetupDialog
      isOpen={isUnsavedSignatureSetupDialogOpen}
      onClose={onUnsavedSignatureSetupDialogClose}
      onAction={closeViewer}
    />
  );
};
